<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconMicrophoneOn_32"
    viewBox="0 0 32 32"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M21 16.833a5 5 0 0 1-10 0V8.5a5 5 0 0 1 10 0zm1.667-1.666a.834.834 0 0 1 1.666 0v1.666c0 4.31-3.3 7.824-7.5 8.25V28.5a.834.834 0 0 1-1.666 0v-3.417c-4.199-.426-7.5-3.94-7.5-8.25v-1.666a.834.834 0 0 1 1.666 0v1.666A6.673 6.673 0 0 0 16 23.5a6.673 6.673 0 0 0 6.667-6.667z"
        clip-rule="evenodd"
    />
</svg>
